angular.module("ainapp")
    .controller("taskController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Task";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.TaskTypes = [];
            MainService.TaskTypesInDropdown().then(function (response) {
                $scope.TaskTypes = response.data;
            })

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.Projects = [];
            MainService.ProjectsInDropdown().then(function (response) {
                $scope.Projects = response.data;
            })



            $scope.changeEndDate = function () {
                if ($scope.City.TimeType == "Day") {
                    var date = new Date($scope.City.StartDate);
                    date = date.setDate(date.getDate() + $scope.City.Duration);
                    $scope.City.EndDate = new Date(date);
                }
                if ($scope.City.TimeType == "Hour") {
                    var date = new Date($scope.City.StartDate);
                    date = date.setTime(date.getTime() + ($scope.City.Duration * 60 * 60 * 1000));
                    $scope.City.EndDate = new Date(date);
                }
                if ($scope.City.TimeType == "Minute") {
                    var date = new Date($scope.City.StartDate);
                    date = date.setTime(date.getTime() + ($scope.City.Duration * 60000));
                    $scope.City.EndDate = new Date(date);
                }
            }


            $scope.Init = function () {
                $scope.City = {
                    Title: "",
                    Description: "",
                    Document: "",
                    TimeType: "Day",
                    Duration: 1,
                    StartDate: new Date(),
                    EndDate: new Date(),
                    EmployeeId: "",
                    TaskTypeId: "",
                }

                $scope.load = 0;
                $scope.changeEndDate();
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.TasksInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Title: {
                                type: "string",
                                editable: false,
                            },
                            Document: {
                                type: "string",
                                editable: false,
                            },
                            StartDate: {
                                type: "date",
                                editable: false,
                            },
                            EndDate: {
                                type: "date",
                                editable: false,
                            },
                            CompletionDate: {
                                type: "date",
                                editable: false,
                            },
                            Duration: {
                                type: "number",
                                editable: false,
                            },
                            TimeType: {
                                type: "string",
                                editable: false,
                            },
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            "TaskType.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Status.Name": {
                                type: "string",
                                editable: false,
                            },
                            "CreatedBy.UseName": {
                                type: "string",
                                editable: false,
                            },
                            "Project.Title": {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Title",
                        title: "Title",
                        },
                    {
                        field: "TaskType.Name",
                        title: "Type",
                        },
                    {
                        field: "CreatedBy.UserName",
                        title: "Created By",
                        },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        },
                    {
                        field: "Project.Title",
                        title: "Project",
                        },
                    {
                        field: "StartDate",
                        title: "Start Date",
                        template: "#= kendo.toString(kendo.parseDate(StartDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Duration",
                        title: "Duration",
                        template: "<p>{{dataItem.Duration}} {{dataItem.TimeType}}</p>"
                        },
                    {
                        field: "EndDate",
                        title: "End Date",
                        template: "#= kendo.toString(kendo.parseDate(EndDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Status.Name",
                        title: "Status",
                        },
                    {
                        field: "CompletionDate",
                        title: "Completion Date",
                        template: "#= kendo.toString(kendo.parseDate(CompletionDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Document",
                        title: "Document",
                        template: '<a href="{{basePath}}{{dataItem.Document}}" target="_blank"> View Document </a>'
                            },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteTask($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.City = data;
                //$scope.$apply();
            }




            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.City.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.City.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else if ($scope.City.Title == "") {
                    toastr.warning("Enter the City");
                } else if ($scope.City.EmployeeId == "") {
                    toastr.warning("Select Employee");
                } else {

                    if ($scope.City.StartDate != null) {
                        $scope.City.StartDateString = $scope.extractDateTime($scope.City.StartDate);
                    }
                    if ($scope.City.EndDate != null) {
                        $scope.City.EndDateString = $scope.extractDateTime($scope.City.EndDate);
                    }

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddTask($scope.City).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error("Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.City.Document = objXhr.responseText;
                            if ($scope.City.Document.includes("error")) {
                                $scope.City.Document = "";
                                toastr.error("Upload Error");
                            } else {
                                $scope.City.Document = objXhr.responseText;
                                toastr.success("File Uploaded");
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info("File Uploading Please Wait");
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error("Upload Error");
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }

                }])
